import { inject, Injectable } from '@angular/core';
import { getPagedFilterParams } from '../../helpers/get-filters';
import { ApiResponsePaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-response.interface';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ReleaseNoteFilter } from 'src/app/shared/interfaces/release-notes/release-note-filter.interface';
import { ReleaseNote } from 'src/app/shared/interfaces/release-notes/release-note.interface';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/shared/interfaces/api-response/api-response.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'
import { LatestReleaseNoteDialogComponent } from 'src/app/secure/modules/release-notes/components/latest-release-note-dialog/latest-release-note-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ReleaseNotesService {
    #httpClient = inject(HttpClient)

    constructor(private modalService: NgbModal) {}

    getReleaseNotes(filter: ReleaseNoteFilter){
        const params = getPagedFilterParams(filter)

        return this.#httpClient
            .get<ApiResponsePaginatedList<ReleaseNote>>(`${environment.baseUrl}release-notes`, { params })
            .pipe(map((x) => x.result))
    }

    getReleaseNoteById(releaseNoteId: number) {
        return this.#httpClient
            .get<ApiResponse<ReleaseNote>>(`${environment.baseUrl}release-notes/${releaseNoteId}`)
            .pipe(map((x) => x.result))
    }

    getLatestReleaseNote() {
        return this.#httpClient
            .get<ApiResponse<ReleaseNote>>(`${environment.baseUrl}release-notes/latest`)
            .pipe(map((x) => x.result))
    }

    createReleaseNote(releaseNote: ReleaseNote): Observable<ReleaseNote> {
        return this.#httpClient.post<ReleaseNote>(`${environment.baseUrl}release-notes`, releaseNote)
    }

    updateReleaseNote(releaseNoteId: number, releaseNote: ReleaseNote) {
        return this.#httpClient
            .put<ApiResponse<ReleaseNote>>(`${environment.baseUrl}release-notes/${releaseNoteId}`, releaseNote)
            .pipe(map((response) => response.result))
    }

    deleteReleaseNote(releaseNoteId: number) {
        return this.#httpClient.delete<void>(`${environment.baseUrl}release-notes/${releaseNoteId}`)
    }

    ackowledgeReleaseNote(releaseNoteId: number) {
        return this.#httpClient.post<void>(`${environment.baseUrl}release-notes/acknowledge/${releaseNoteId}`, {})
    }

    checkForLatestReleaseDialog() {
        this.getLatestReleaseNote().subscribe(releaseNote => {
            const modalRef = this.modalService.open(LatestReleaseNoteDialogComponent, { size: 'lg', scrollable: true })
            modalRef.componentInstance.releaseNote = releaseNote
        })
    }
}
